import ReactDOM from "react-dom";
import App from "../components/filters/App"; // eslint-disable-line
import VideoPlayer from "../components/VideoPlayer";

/**
 * Artist Index
 */

const PageArtistIndex = ($) => {
	if ($("body").hasClass("page-template-artist-index")) {
		VideoPlayer($);
		const artistIndexGrid = document.getElementById("js-artist-filter");
		ReactDOM.render(
			<App {...artistIndexGrid.dataset}/>, artistIndexGrid);
	}
};

export default PageArtistIndex;
